import { PaymentSourceDetector, resolvePaymentSource } from "@/lib/paymentSourcePolicy";

export const PAYMENT_STORAGE_KEY = "payment_gateway_session";
export const ONE_HOUR_SECONDS = 3600;
/** Forwarded by middleware so root layout can resolve utm_source / source without useSearchParams. */
export const PAYMENT_SEARCH_HEADER = "x-request-search";

/**
 * Cookie value is the matched gateway code (for example snappay or grand-bazaar),
 * not a fixed enum. Max-Age stays 3600 seconds.
 * Pass that code as GraphQL `source` on gateway lists and on pay.
 */
export function resolveGatewayCode(
  detectors: PaymentSourceDetector[],
  utmSource?: string | null,
  sourceParam?: string | null,
  referrer?: string | null,
): string | null {
  return resolvePaymentSource(detectors, {
    utmSource,
    source: sourceParam,
    referrer,
  });
}

export function paymentSourceCookie(code: string): string {
  return `${PAYMENT_STORAGE_KEY}=${encodeURIComponent(code)}; max-age=${ONE_HOUR_SECONDS}; path=/; SameSite=Lax`;
}

export function firstQueryValue(value: string | string[] | undefined | null): string | null {
  if (Array.isArray(value)) return value[0]?.trim() || null;
  return value?.trim() || null;
}
